/* eslint-disable react-hooks/exhaustive-deps */
import { ConferirNucleoOptions } from 'helpers/enums/VerificarVotoEnum';
import { isNullOrUndefined } from 'helpers/utils/HTMLUtils';
import {
  getMergedParamsFromObject,
  toRequest,
} from 'helpers/utils/RequestUtils';
import { getAssembleiasAssessorEndpoint } from 'library/Apis';
import React, { useCallback, useLayoutEffect, useState } from 'react';
import ApiService from 'services/ApiService';

export interface agenciaNucleoRepresentante {
  codigoAgencia: string;
  nucleos: {
    numeroNucleo: string;
    representante?: string | null;
  }[];
}

export default function useVerificarInconsistencia(
  idEvento?: number,
  idPauta?: number
): [
  ConferirNucleoOptions | undefined,
  React.Dispatch<React.SetStateAction<ConferirNucleoOptions | undefined>>,
  boolean,
  agenciaNucleoRepresentante[] | undefined,
  (
    selecionados: string[],
    idItemPauta: number | null,
    ausencia: boolean
  ) => Promise<any>
] {
  const [selectValue, setValue] = useState<ConferirNucleoOptions | undefined>();
  const [loading, setLoading] = useState<boolean>(false);
  const [lines, setLines] = useState<
    agenciaNucleoRepresentante[] | undefined
  >();

  const url = `${getAssembleiasAssessorEndpoint(
    '1'
  )}voto-presencial/evento-pauta-voto-lote`;

  const getVotosParaVerificar = useCallback(() => {
    return toRequest(
      ApiService.get,
      [
        `${url}?${getMergedParamsFromObject({
          idEvento: idEvento!,
          idPauta: idPauta!,
          isPresentes: selectValue === ConferirNucleoOptions.NucleosPresentes,
        })}`,
      ],
      'getNucleosEAgencias'
    );
  }, [idEvento, idPauta, selectValue]);

  const alterarVotosNucleos = useCallback(
    (selecionados: string[], idItemPauta: number | null, ausencia: boolean) => {
      return new Promise<void>((resolve, reject) => {
        toRequest(
          ApiService.post,
          [
            url,
            {
              agsNucleos: selecionados.map((s) => {
                return {
                  codigoAgencia: s.split('-')[0],
                  numeroNucleo: s.split('-')[1],
                };
              }),
              ...(selectValue === ConferirNucleoOptions.NucleosPresentes &&
              isNullOrUndefined(idItemPauta)
                ? { semManifestacaoVoto: true }
                : { ausencia }),
              ausencia: ausencia,
              idEvento: idEvento,
              idPauta: idPauta,
              idItemPauta: idItemPauta,
              tipoVotoLote:
                selectValue === ConferirNucleoOptions.NucleosPresentes ? 0 : 1,
            },
          ],
          'alterarVotosNucleos'
        )
          .then(() => {
            getVotosParaVerificar()
              .then(({ data }: { data?: agenciaNucleoRepresentante[] }) => {
                setLines(data!);
                resolve();
              })
              .catch(() => {
                reject();
              });
          })
          .catch(() => {
            reject();
          });
      });
    },
    [idEvento, idPauta, selectValue]
  );

  useLayoutEffect(() => {
    if (selectValue) {
      if (lines?.length) setLines([]);
      setLoading(true);
      getVotosParaVerificar()
        .then(({ data }: { data?: agenciaNucleoRepresentante[] }) => {
          setLines(data!);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLines([]);
    }
  }, [selectValue]);

  return [selectValue, setValue, loading, lines, alterarVotosNucleos];
}
